<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <div class="main-question">
            <div class="question-header">
              <h3 class="title">
                <div class="item">
                  {{ $t('cs103.title') }}
                </div>
              </h3>
            </div>
            <div class="question-write">
              <div class="body">
                <!-- 필수 : required -->
                <div class="field type required">
                  <div class="caption">
                    {{ $t('cs103.typeLabel') }}
                  </div>
                  <div class="content">
                    <div class="contain">
                      <div class="item select">
                        <div class="formSelect" ref="select01" @click="openSelect01">
                          <div class="formSelectList">
                            <input :value="selectedType.value" type="text" :placeholder="$t('cs103.typeSelectPlaceholder')" readonly />
                          </div>
                          <div class="formSelectPopup select01">
                            <div class="formSelectPopup-container">
                              <div class="outer">
                                <div class="inner">
                                  <div class="formSelectPopup-box">
                                    <div class="formSelectPopup-zone">
                                      <div class="formSelectPopup-header">
                                        <input type="text" :placeholder="$t('cs103.typeSelectPlaceholder')" />
                                      </div>
                                      <ul class="formSelectPopup-body">
                                        <li v-for="type in typeList" :key="type.key">
                                          <label>
                                            <input type="radio" v-model="selectType" :value="type.key"/>
                                            <input type="checkbox" />
                                            <i></i>
                                            <span>{{ type.value }}</span>
                                          </label>
                                        </li>
                                      </ul>
                                      <div class="formSelectPopup-footer">
                                        <button class="formSelectPopup-cancel">
                                          {{ $t('common.cancel') }}
                                        </button>
                                        <!-- 비활성(Attribute) : disabled -->
                                        <button class="formSelectPopup-confirm">
                                          {{ $t('common.confirm') }}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 필수 : required -->
                <div class="field title required">
                  <div class="caption">
                    {{ $t('cs103.titleLabel') }}
                  </div>
                  <div class="content">
                    <div class="contain">
                      <div class="item input">
                        <input type="text" :placeholder="$t('cs103.titlePlaceholder')" v-model="title"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field write">
                  <textarea :placeholder="$t('cs103.contentPlaceholder')" v-model="content"></textarea>
                </div>
              </div>
            </div>
            <div class="question-button">
              <button class="cancel" @click="moveMenu('/CS101')">
                {{ $t('common.cancel') }}
              </button>
              <!-- 비활성(Attribute) : disabled -->
              <button class="registration" @click="postData" :disabled="!passValidation">
                {{ $t('common.register') }}
              </button>
            </div>
          </div>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="alert typeConfirm">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body" v-html="alertMessage">
                  </div>
                  <div class="footer">
                    <button class="cancel">
                      {{ $t('common.cancel') }}
                    </button>
                    <button class="confirm" @click="confirmAlert">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div><div class="formSelectPopup select01">
      <div class="formSelectPopup-container">
        <div class="outer">
          <div class="inner">
            <div class="formSelectPopup-box">
              <div class="formSelectPopup-zone" ref="m_select01" @click="openSelect01">
                <div class="formSelectPopup-header">
                  <input type="text" :placeholder="$t('cs103.typeSelectPlaceholder')" />
                </div>
                <ul class="formSelectPopup-body">
                  <li v-for="type in typeList" :key="type.key">
                    <label>
                      <input type="radio" v-model="selectType" :value="type.key"/>
                      <input type="checkbox" />
                      <i></i>
                      <span>{{ type.value }}</span>
                    </label>
                  </li>
                </ul>
                <div class="formSelectPopup-footer">
                  <button class="formSelectPopup-cancel">
                    {{ $t('common.cancel') }}
                  </button>
                  <!-- 비활성(Attribute) : disabled -->
                  <button class="formSelectPopup-confirm">
                    {{ $t('common.confirm') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'
import {csService, settingService} from '../../router'

export default {
  name: 'CS103',
  data () {
    return {
      selectType: '',
      title: '',
      content: '',
      alertBodyHTML: '',
      callback: null
    }
  },
  created: function () {
  },
  mounted: function () {
    this.setData()
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  methods: {
    setData: function () {
    },
    setTextareaTemplate: function () {
      this.content = this.selectedType.template
    },
    postData: function () {
      csService.postInquire(this.selectType, this.title, this.content).then(response => {
        if (response.statusCode === 200) {
          settingService.insertPushAlarm({
            funcId: '6',
            pageId: 'CS-103',
            message: this.userInfo.userName,
            pageQuery: `?inquire_id=${response.data.inquireId}`
          }).then(() => {
            this.openAlert(this.$t('cs103.registeredAlert'), '/CS102?inquire_id=' + response.data.inquireId)
          })
        } else if (response.statusCode !== 200) {
          this.openAlert(this.$t('cs103.registerFailedAlert'), null)
        }
      }).catch(error => {
        console.log('getClubInfoListByStatusActive.err.===>', error)
      })
    }
  },
  computed: {
    typeList: function () {
      return [
        {
          key: 'service',
          value: this.$t('cs103.typeService'),
          template: this.$t('cs103.templateService')
        },
        {
          key: 'event',
          value: this.$t('cs103.typeEvent'),
          template: this.$t('cs103.templateEvent')
        },
        {
          key: 'update',
          value: this.$t('cs103.typeUpdate'),
          template: this.$t('cs103.templateUpdate')
        }
      ]
    },
    selectedType: function () {
      if (this.typeList.find(it => it.key === this.selectType) === undefined) return {}
      return this.typeList.find(it => it.key === this.selectType)
    },
    passValidation: function () {
      if (!this.title) return false
      if (!this.selectType) return false
      if (!this.content) return false
      return true
    }
  },
  watch: {
    selectType: function () {
      this.setTextareaTemplate()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cs/CS103.vue